import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Handover } from 'src/app/interfaces/handover';

@Component({
  selector: 'app-home-content-inbox-edition-team',
  templateUrl: './home-content-inbox-edition-team.component.html',
  styleUrls: ['./home-content-inbox-edition-team.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentInboxEditionTeamComponent implements OnInit {
  @Input() handoversInboxEditionTeam: Handover[] | undefined;
  @Input() totalHandoversInboxEditionTeam: number | undefined;
  @Input() searchEditionTeam: string | undefined;
  @Output() reloadEditionTeam = new EventEmitter<boolean>();
  @Output() eventShowInboxEdition = new EventEmitter<boolean>();
  @Output() handoversEditionTeamWithFilter = new EventEmitter<string>();

  textSearch = '';
  constructor() {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    // Agrego esta linea para que Husky deje hacer commit y push.
    this.textSearch = this.searchEditionTeam ? this.searchEditionTeam : '';
  }

  eventReload(reload: boolean) {
    this.reloadEditionTeam.emit(true);
  }
  showInboxEdition() {
    this.eventShowInboxEdition.emit(true);
  }

  getHandoversHomeEditionTeamWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversEditionTeamWithFilter.emit(searchText);
  }
}
